import Utils from '@/ecm/common/Utils'
export default class ContentTypeRight {
    constructor (dto) {
        this.uuid = Utils.object.getUUID()
        this.id = 0
        this.roleTypeID = ''
        this.accessRightId = ''
        this.digitalSignatureConfigId = ''
        this.conditionStr = ''
        this.displayConditionStr = ''

        if (dto) {
            this.id = dto.Id
            this.roleTypeID = dto.RoleTypeID + ''
            this.accessRightId = dto.AccessRightId + ''
            this.digitalSignatureConfigId = dto.DigitalSignatureConfigId + ''
            this.conditionStr = dto.ConditionStr
            this.displayConditionStr = dto.DisplayConditionStr
        }
    }

    toDto () {
        return {
            Id: this.id,
            RoleTypeID: this.roleTypeID,
            AccessRightId: this.accessRightId,
            DigitalSignatureConfigId: this.digitalSignatureConfigId,
            ConditionStr: this.conditionStr,
        }
    }
}
